import { render, staticRenderFns } from "./DoctorSalesStat.vue?vue&type=template&id=40e79566&scoped=true"
import script from "./DoctorSalesStat.vue?vue&type=script&lang=js"
export * from "./DoctorSalesStat.vue?vue&type=script&lang=js"
import style0 from "./DoctorSalesStat.vue?vue&type=style&index=0&id=40e79566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e79566",
  null
  
)

export default component.exports